import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import apiService from "../../service/apiService";
import { useNavigate } from "react-router-dom";
import { FormControl, InputLabel, Select } from "@mui/material";
import Header from "../../components/Header";
import axios from "axios";
import {
    Button,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    MenuItem,
    Pagination,
} from "@mui/material";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { FaRegEdit, FaTrash } from "react-icons/fa";

const ChildTechnologyPark = () => {
    const location = useLocation();
    const { technologyParkId } = location.state || {};
    const [data, setData] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [newTech, setNewTech] = useState(""); // To store new technology value
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const pageSize = 10;
    const totalItems = data?.length || 0;
    const totalPages = Math.ceil(totalItems / pageSize);
    const [farmers, setFarmers] = useState([]);


    const [editData, setEditData] = useState({
        producerGroupName: "",
        farmerName: "",
        plotSize: "",
        noOfReplication: "",
        details: [],
    });


    const handleBack = () => {
        navigate(-1);
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleAddTechnology = async () => {
        console.log("Adding technology:", newTech);
        setOpenDialog(false);
    };

    const handleDelete = async (technologyParkId) => {
        // Implement delete logic
        console.log("Deleting technology park with ID:", technologyParkId);
    };
    useEffect(() => {
        // Fetch farmers from the API
        const fetchFarmers = async () => {
            try {
                const response = await apiService.get("/farmers/get-all-farmers");
                if (response.data.status && response.data.body) {
                    setFarmers(response.data.body);
                }
            } catch (error) {
                console.error("Error fetching farmers:", error);
            }
        };

        fetchFarmers();
    }, []);

    const handleFarmerChange = (event) => {
        const selectedFarmerIds = event.target.value;
        setEditData({ ...editData, farmerIds: selectedFarmerIds });
    };



    const handleEdit = async (technologyParkId) => {
        try {
            const response = await apiService.get(`/technology/child/${technologyParkId}`);
            const { replications, farmerIds, noOfReplication, plotSize } = response.data;
    
            // Map response data to state
            const editData = {
                details: replications?.map((rep) => ({
                    seedVarietyName: rep.seedVarietyName || "",
                    yieldPerHaInQtl: rep.yieldPerHaInQtl || "",
                    yieldPerPlot: rep.yieldPerPlot || "",
                })) || [],
                farmerIds: farmerIds || [], // Ensure farmerIds exists
                noOfReplication: noOfReplication || "",
                plotSize: plotSize || "",
            };
    
            setEditData(editData);
            setOpenDialog(true);
        } catch (err) {
            console.error("Error fetching data for edit:", err);
        }
    };
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSaveChanges = async () => {
        try {
            // Validate and prepare the payload
            const payload = {
                PlotSize: parseFloat(editData.plotSize), 
                NoOfReplication: parseInt(editData.noOfReplication, 10), 
                FarmerIds: editData.farmerIds, 
                Replications: editData.details.map((rep, index) => ({
                    SeedVarietyId: rep.seedVarietyId || index + 1, 
                    YieldPerPlot: parseFloat(rep.yieldPerPlot), 
                    YieldPerHaInQtl: parseFloat(rep.yieldPerHaInQtl), 
                })),
            };
    
            // Make the API request
            const response = await apiService.put(`/technology/detailedInfo/${technologyParkId}`, payload);
    
            console.log("Data saved successfully:", response.data);
            handleCloseDialog(); // Close the dialog on success
            fetchData();
        } catch (err) {
            console.error("Error saving changes:", err.response?.data || err.message);
        }
    };
    
    

    const fetchData = async () => {
        if (technologyParkId) {
            try {
                const response = await apiService.get(`/technology/childdetails/${technologyParkId}`);
                setData(response.data);
            } catch (err) {
                console.error("Error fetching data:", err);
                setData([]); 
            }
        }
    };
    
    useEffect(() => {
      fetchData();
    }, [technologyParkId]);

    return (
        <div className="container-fluid" style={{ maxHeight: "100vh", overflowX: "auto" }}>
            <div className="row mt-3">
                <div className="d-flex justify-content-between align-items-center">
                    <Header title="Technology Park Details" />
                    <div className="d-flex align-items-center">
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                                gap: 2,
                                marginTop: 2,
                                marginBottom: 2,
                                paddingLeft: 2,
                            }}
                        >
                            <Button
                                startIcon={<ArrowBack />}
                                onClick={handleBack}
                                sx={{
                                    backgroundColor: "#1976d2",
                                    color: "white",
                                    "&:hover": {
                                        backgroundColor: "#1565c0",
                                    },
                                    padding: "6px 16px",
                                }}
                            >
                                Back
                            </Button>
                            {/* <Button
                                variant="contained"
                                color="primary"
                                onClick={handleOpenDialog}
                                sx={{
                                    padding: "6px 16px",
                                }}
                            >
                                Add
                            </Button> */}
                        </Box>
                    </div>
                </div>
            </div>
            <div className="row mt-3">
            <div className="col-lg-12">
            <div className="card">
                <div className="card-body table-responsive p-0" 
                style={{
                minHeight: "60vh",
                overflowX: "auto",
                scrollbarWidth: "thin", 
                scrollbarColor: "#ccc transparent", 
                }}>
                <table className="table table-hover table-bordered text-nowrap mb-0">
                    <thead>
                        <tr>
                            <th >Variety Name</th>
                            <th >Plot Size</th>
                            <th >No of Replication</th>
                            <th >Yield Per Plot </th>
                            <th >Yield Per Ha (Qtl)</th>
                            {/* <th >Pg Names</th>
                            <th >Farmer's Name</th> */}
                            {/* <th >Actions</th> */}
                        </tr>
                    </thead>
                    <tbody>
                           {data.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.seedVarietyName}</td>
                                    <td>{item.plotSize || 'NA'}</td>
                                    <td>{item.noOfReplication}</td>
                                    <td>{item.yieldPerPlot}</td>
                                    <td>{item.yieldPerHaInQtl}</td>
                                    {/* <td>{item.pgnames || "NA"}</td>
                                    <td>{item.farmersname || "NA"}</td> */}
                                    {/* <td>
                                        <Box sx={{ display: "flex", gap: 1 }}>
                                             <button
                                                className="btn btn-md"
                                                onClick={() => handleDelete(replication.technologyParkId)}
                                                title="Delete"
                                            >
                                                <FaTrash />
                                            </button>
                                            <button
                                                className="btn btn-md"
                                                onClick={() => handleEdit(item.technologyParkId)}
                                                title="Edit"
                                            >
                                                <FaRegEdit />
                                            </button>
                                        </Box>
                                    </td> */}
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            </div>
            </div>
            </div>
            <div className="row mt-2">
            <div className="d-flex justify-content-between pb-0">
                <div className="p-2">
                    Showing {(page - 1) * pageSize + 1} to {Math.min(page * pageSize, totalItems)} of {totalItems} items
                </div>
                <div className="p-2">
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        showFirstButton
                        showLastButton
                    />
                </div>
            </div>
            </div>
            {/* Dialog for adding technology */}
            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle>Add New Technology</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Technology"
                        value={newTech}
                        onChange={(e) => setNewTech(e.target.value)}
                        fullWidth
                        sx={{ marginBottom: 2 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleAddTechnology} color="primary">
                        Add
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Dialog for editing */}
            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle>Edit Technology Park</DialogTitle>
                <DialogContent>
                <FormControl fullWidth margin="normal">
                        <InputLabel id="farmer-select-label">Farmer Names</InputLabel>
                        <Select
                            labelId="farmer-select-label"
                            multiple
                            value={editData.farmerIds || []} // Ensure it's an array
                            onChange={handleFarmerChange}
                            renderValue={(selected) =>
                                selected
                                    .map((id) => farmers.find((farmer) => farmer.farmerId === id)?.farmerName)
                                    .join(", ")
                            }
                        >
                            {farmers.map((farmer) => (
                                <MenuItem key={farmer.farmerId} value={farmer.farmerId}>
                                    {farmer.farmerName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField
                        label="Plot Size"
                        value={editData.plotSize || ""}
                        onChange={(e) => setEditData({ ...editData, plotSize: e.target.value })}
                        fullWidth
                        name="plotSize"
                        sx={{ marginBottom: 2 }}
                    />
                    <TextField
                        label="No of Replications"
                        value={editData.noOfReplication || ""}
                        onChange={(e) => setEditData({ ...editData, noOfReplication: e.target.value })}
                        fullWidth
                        disabled
                        name="noOfReplication"
                        sx={{ marginBottom: 2 }}
                        
                    />
                    
                    {editData.details && editData.details.map((replication, index) => (
    <div key={index}>
        <TextField
            label={`Seed Variety Name ${index + 1}`}
            value={replication.seedVarietyName || ""}
            onChange={(e) => {
                const updatedReplications = [...editData.details];
                updatedReplications[index].seedVarietyName = e.target.value;
                setEditData({ ...editData, details: updatedReplications });
            }}
            fullWidth
            sx={{ marginBottom: 2 }}
        />
        <TextField
            label={`Yield Per Ha (Qtl) ${index + 1}`}
            value={replication.yieldPerHaInQtl || ""}
            onChange={(e) => {
                const updatedReplications = [...editData.details];
                updatedReplications[index].yieldPerHaInQtl = e.target.value;
                setEditData({ ...editData, details: updatedReplications });
            }}
            fullWidth
            sx={{ marginBottom: 2 }}
        />
        <TextField
            label={`Yield Per Plot ${index + 1}`}
            value={replication.yieldPerPlot || ""}
            onChange={(e) => {
                const updatedReplications = [...editData.details];
                updatedReplications[index].yieldPerPlot = e.target.value;
                setEditData({ ...editData, details: updatedReplications });
            }}
            fullWidth
            sx={{ marginBottom: 2 }}
        />
    </div>
))}

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleSaveChanges} color="primary">
                        Save Changes
                    </Button>
                </DialogActions>
            </Dialog>


        </div>
    );
};

export default ChildTechnologyPark;
